const config = {
  actions: {
    // string: URL friendly string
    REDIRECT: 'redirect', // For 404 Page
  }
}

module.exports = config;
